import React from 'react';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { goBackTo } from '../../utils/formReturn';

// "Back to Jo Smith" at the top of a page opened from a guard's Guard Information page (their duties, a
// duty's details, the edit form): back to that page (utils/formReturn goBackTo). Nothing until the guard
// is known (guardId and their name).
export function backToGuardLabel(name) {
	const text = name == null ? '' : String(name).trim();
	return text ? 'Back to ' + text : '';
}

function BackToGuard({ history, guardId, name }) {
	const label = backToGuardLabel(name);
	if (!label || guardId == null || String(guardId) === 'null' || String(guardId) === '') {
		return null;
	}
	return (
		<div className="mb-2">
			<Button color="secondary" outline size="sm" onClick={() => goBackTo(history, '/guard-info/' + guardId)}>
				<i className="mdi mdi-arrow-left"></i>&nbsp;{label}
			</Button>
		</div>
	);
}

export default withRouter(BackToGuard);
